export default function Logo({ dark = false, compact = false }) {
  return (
    <a
      href="#inicio"
      data-testid="logo-link-home"
      className="flex items-center gap-3 group"
      onClick={(e) => e.preventDefault()}
    >
      <svg viewBox="0 0 64 64" className="h-9 w-9 shrink-0 transition-transform duration-500 group-hover:rotate-6" aria-hidden="true">
        <defs>
          <linearGradient id="lg-logo" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#FF6A3D" />
            <stop offset="1" stopColor="#E64A19" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="16" fill="url(#lg-logo)" />
        <path
          d="M32 12c6.6 8.2 11 13.9 11 19.4 0 6.4-4.9 11.1-11 11.1s-11-4.7-11-11.1C21 25.9 25.4 20.2 32 12Z"
          fill="#fff"
        />
        <rect x="18" y="46" width="5" height="7" rx="1.5" fill="#fff" opacity=".9" />
        <rect x="26" y="42" width="5" height="11" rx="1.5" fill="#fff" opacity=".75" />
        <rect x="34" y="44" width="5" height="9" rx="1.5" fill="#fff" opacity=".6" />
        <rect x="42" y="40" width="5" height="13" rx="1.5" fill="#fff" opacity=".45" />
      </svg>
      {!compact && (
        <span className="leading-none">
          <span className={`font-display block text-[15px] font-extrabold tracking-tight ${dark ? "text-white" : "text-brand-ink"}`}>
            HAMBURGER <span className="text-brand-orange">INVITRO</span>
          </span>
          <span className={`block mt-1 font-mono2 text-[9px] uppercase tracking-[0.24em] ${dark ? "text-slate-400" : "text-slate-500"}`}>
            Tecnología IVD · Barranquilla
          </span>
        </span>
      )}
    </a>
  );
}
